import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

// Show the Embrace tenant button only when its federation IdP is enabled for this
// build (set in CI when the env's embrace-oidc-issuer SSM param is present).
const EMBRACE_LOGIN_ENABLED =
  import.meta.env.VITE_EMBRACE_LOGIN_ENABLED === 'true';

export default function Login() {
  const { status, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authed') navigate('/', { replace: true });
  }, [status, navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-shell font-sans">
      <div className="w-full max-w-sm rounded-2xl border border-hair bg-white p-8 shadow-sm">
        <div className="text-[18px] font-bold text-ink">Embrace Returns</div>
        <div className="mt-0.5 text-[11px] uppercase tracking-[1px] text-muted">
          Powered by Pivotal
        </div>
        <p className="mt-4 text-[13px] leading-relaxed text-muted">
          Sign in to see leads returned to you from Simply Lending.
        </p>
        <button
          onClick={() => signIn('Entra')}
          className="mt-6 w-full rounded-lg bg-navy py-2.5 text-[13.5px] font-semibold text-white transition-opacity hover:opacity-90"
        >
          Sign in with Simply
        </button>
        {EMBRACE_LOGIN_ENABLED && (
          <button
            onClick={() => signIn('EntraEmbrace')}
            className="mt-3 w-full rounded-lg border border-navy py-2.5 text-[13.5px] font-semibold text-navy transition-colors hover:bg-navy/5"
          >
            Sign in with Embrace
          </button>
        )}
      </div>
    </div>
  );
}
